import { FC, useCallback } from 'react';
import intl from 'react-intl-universal';
import { useSelector, useDispatch } from 'react-redux';
import { Typography, tailwindOverride } from '@getsynapse/design-system';
import {
  selectTaskPredecessorsWithPermissions,
  setDependencyToRemove,
} from 'state/TaskDependencies/TaskDependenciesSlice';
import { LinkedTask, RelationshipType } from 'types/store/taskDependencies';
import { PATHS } from 'utils/constants';
import LinkedTaskCard from 'Organisms/TaskDependencies/LinkedTaskCard/LinkedTaskCard';

interface PredecessorsProps {
  projectId: string;
}
const Predecessors: FC<PredecessorsProps> = ({ projectId }) => {
  const dispatch = useDispatch();
  const predecessors = useSelector(selectTaskPredecessorsWithPermissions);
  const route = `${PATHS.PROJECT_PAGE}/${projectId}/tasks/`;

  const handleRemoveDependency = useCallback(
    (linkedTask: LinkedTask) => {
      dispatch(
        setDependencyToRemove({
          id: linkedTask.id,
          displayId: linkedTask.displayId,
          name: linkedTask.name,
          relationshipType: RelationshipType.DependsOn,
        })
      );
    },
    [dispatch]
  );

  if (predecessors.length === 0) {
    return null;
  }

  return (
    <div className={tailwindOverride('w-full h-auto', 'flex flex-col gap-y-2')}>
      <Typography variant='caption' weight='medium' className='text-neutral'>
        {intl.get('TASKS.TASK_DETAIL_PAGE.DEPENDENCIES.DEPENDS_ON')}
      </Typography>
      {predecessors.map(
        ({ permissions, isTaskOverDue, overlapingDates, ...linkedTask }) => (
          <LinkedTaskCard
            linkedTask={linkedTask}
            route={route + linkedTask.id}
            permissions={permissions}
            key={linkedTask.id}
            onRemoveDependency={handleRemoveDependency}
            isTaskOverDue={isTaskOverDue}
            overlapingDates={overlapingDates}
          />
        )
      )}
    </div>
  );
};

export default Predecessors;
